import { createFileRoute } from '@tanstack/react-router';
import { RelationsClient } from '@/features/relations/RelationsClient';

export const Route = createFileRoute('/_shell/relations/')({
  component: RelationsClient,
});
